<template>
  <v-banner single-line v-if="customer.email">
    <!-- <v-icon slot="icon" color="blue" size="36">profile</v-icon> -->
    <div>
      <b class="overline">Account : </b>
      <span class="caption">{{customer.name}} - {{customer.description}}</span>
    </div>
    <div>
      <b class="overline">Billing Email : </b>
      <span class="caption">{{customer.email}}</span>
    </div>

    <template v-slot:actions>
      <div>
        <b class="overline">Balance :</b>
        <span class="caption">{{balance}}</span>
      </div>
      <v-btn :loading="loading" @click="openBilling" color="primary" text>Billing Portal</v-btn>
    </template>
  </v-banner>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    customer: Object
  },
  methods: {
    openBilling() {
      this.loading = true;
      var me = this;
      var callback = function(res) {
        me.loading = false;
        if (res.status && res.data && res.data.url) {
          window.open(res.data.url, "_blank");
        } else {
          me.$toastr("error", me.lang.error);
        }
      };
      this.adminUser.openBilling(callback);
    }
  },
  computed: {
    ...mapState(["adminUser"]),
    balance() {
      const balance = ((this.customer.balance * -1) / 100)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return balance + " " + this.customer.currency;
    }
  },
  data() {
    return {
      loading: false
    };
  }
};
</script>

<style>
</style>